import {AuthSessionService} from '../../shared/auth/auth-session.service';
import {Component, inject, signal} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterOutlet} from '@angular/router';
import {filter} from 'rxjs';
import {CurrentUserContextService} from '../../shared/services/current-user-context.service';
import {RoleInvitationService} from '../role-invitations/role-invitation.service';
import {UserProfile} from '../user-profile/user-profile';

@Component({
  selector: 'app-manage-user-profile',
  standalone: true,
  imports: [
    RouterLink,
    RouterOutlet,
    UserProfile,
  ],
  templateUrl: './manage-user-profile.html',
  styleUrl: './manage-user-profile.scss',
})
export class ManageUserProfile {
  private readonly authSession = inject(AuthSessionService);
  private currentUserContext = inject(CurrentUserContextService);
  private readonly roleInvitationService = inject(RoleInvitationService);
  /** Business/certificate tabs and delegation stay hidden until the profile is saved once. */
  protected readonly profileCompleted = this.currentUserContext.profileCompleted;
  protected readonly pendingInvitationCount = this.roleInvitationService.pendingCount;
  private readonly router = inject(Router);
  protected readonly showHomeView = signal(true);

  constructor() {
    // ensure the shared profile context is loaded (cached/no-op if already loaded)
    this.currentUserContext.load().subscribe({
      error: () => {
      }
    });

    this.roleInvitationService.refreshPendingCount().subscribe({
      error: () => {
      }
    });

    const url = this.router.url.split('?')[0].split('#')[0];
    this.showHomeView.set(url === '/profile');

    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    ).subscribe(() => {
      const currentUrl = this.router.url.split('?')[0].split('#')[0];
      this.showHomeView.set(currentUrl === '/profile');
    });
  }

  logout(): void {
    this.authSession.logout();
  }
}
